import { Component, ViewChild, OnInit } from '@angular/core';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';



interface Certificate {
  name: string;
  provider: string;
  link: string;
  src: string;

}

const CERTIFICATES: Certificate[] = [

  {
    name: 'Best project at the bal of projects',
    provider: 'ESPRIT University',
    link: "",
    src: "/assets/images/certifications/best_project_bal_of_projects.jpg"

  },
  {
    name: 'Ask Questions to Make Data-Driven Decisions',
    provider: 'Google',
    link: 'https://coursera.org/verify/H68JKL4JUVDW',
    src: '/assets/images/certifications/Certificate-Google_DataAnalytics-1-8.png'
  },
  {
    name: 'Foundations: Data, Data, Everywhere',
    provider: 'Google',
    link: 'https://coursera.org/verify/SW659L4FLZUM',
    src: '/assets/images/certifications/Certificate-Google_DataAnalytics-2-8.png'
  },
  {
    name: 'Prepare Data for Exploration',
    provider: 'Google',
    link: 'https://coursera.org/verify/NUZDEFG98XZ8',
    src: '/assets/images/certifications/Certificate-Google_DataAnalytics-3-8.png'
  },
  {
    name: 'Process Data from Dirty to Clean',
    provider: 'Google',
    link: 'https://coursera.org/verify/8EUFFX8K6VBR',
    src: '/assets/images/certifications/Certificate-Google_DataAnalytics-4-8.png'
  },
  {
    name: 'Analyze Data to Answer Questions',
    provider: 'Google',
    link: 'https://coursera.org/verify/C9ZQTCWYQH2K',
    src: '/assets/images/certifications/Certificate-Google_DataAnalytics-5-8.png'
  },
  {
    name: 'What is Data Science?',
    provider: 'IBM',
    link: 'https://coursera.org/verify/ZETN2C8BEVTX',
    src: '/assets/images/certifications/Certificate-IBM_What_is_Data_science.png'
  },
  {
    name: 'Data Science Orientation Badge',
    provider: 'IBM on Coursera',
    link: "https://www.credly.com/go/5jJys2DN",
    src: "/assets/images/certifications/DataScienceOrientation_Badge.jpg"

  },
  {
    name: 'Data Science Methodology',
    provider: 'IBM',
    link: "https://courses.cognitiveclass.ai/certificates/2763acb81f1c4248bf07fbe3a1d35179",
    src: "/assets/images/certifications/DataScienceMethodology.png"

  },
  {
    name: 'Sentiment Analysis on Tunisian Google Play Store',
    provider: 'Zindi',
    link: "https://zindi.africa/users/AnasCharfi/competitions/certificate",
    src: "/assets/images/certifications/AnasCharfi - Zindi.png"

  },
  {
    name: 'ML Hackathon',
    provider: 'DSC Tunisia',
    link: "",
    src: "/assets/images/certifications/Ml Competition -DSC Tunisia-.jpg"

  },
  {
    name: 'Hub Organizer 2020',
    provider: 'Google LLC',
    link: "",
    src: "/assets/images/certifications/Hash Code 2020 - Hub Organizer.png"

  },
  {
    name: 'Hub Organizer 2019',
    provider: 'Google LLC',
    link: "",
    src: "/assets/images/certifications/Hash Code 2019 - Hub Organizer.png"

  },
  {
    name: 'Python',
    provider: 'Solo Learn',
    link: "https://www.sololearn.com/Certificate/1073-12105060/jpg/",
    src: "/assets/images/certifications/python-sololearn.jpg"

  },
  {
    name: 'Php',
    provider: 'Solo Learn',
    link: "https://www.sololearn.com/Certificate/1059-12105060/jpg/",
    src: "/assets/images/certifications/php-sololearn.jpg"

  },
  {
    name: 'SQL',
    provider: 'Solo Learn',
    link: "https://www.sololearn.com/certificates/course/en/12105060/1060/landscape/png",
    src: "/assets/images/certifications/sql-sololearn.png"
  },
  {
    name: 'Appreciation Certificate',
    provider: 'Google Developer Students Club Leader',
    link: "",
    src: "/assets/images/certifications/GDSC_Esprit_University.jpg"
  },


];

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.css']
})


export class CertificatesComponent implements OnInit {


  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;
  pauseOnFocus = true;

  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;

  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (this.unpauseOnArrow && slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }




  constructor() {

  }


  ngOnInit(): void {

  }

  certificates = CERTIFICATES;



}
